import { render, staticRenderFns } from "./ModelsIcon.vue?vue&type=template&id=9c2427a8&"
import script from "./ModelsIcon.vue?vue&type=script&lang=js&"
export * from "./ModelsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports